import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { GastroHero } from '../../components/gastro-landing/GastroHero';
import { SocialProof } from '../../components/gastro-landing/SocialProof';
import { ProblemSection } from '../../components/gastro-landing/ProblemSection';
import { SmartPricing } from '../../components/gastro-landing/SmartPricing';
import { GastroStandard } from '../../components/gastro-landing/GastroStandard';
import { Professionalize } from '../../components/gastro-landing/Professionalize';
import { TargetAudience } from '../../components/gastro-landing/TargetAudience';
import { GastroProducts } from '../../components/gastro-landing/GastroProducts';
import { FinalCTA } from '../../components/gastro-landing/FinalCTA';
import { SEOBlock } from '../../components/gastro-landing/SEOBlock';
import type { GastroLandingProps } from '../../types/gastro-landing';

export default function GastroLanding({ stats, featuredProducts, appUrl, loginUrl, whatsappUrl, mayoristaPlusDiscount, copy }: GastroLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>{copy.metaTitle}</title>
        <meta name="description" content={copy.metaDescription} />
        <link rel="canonical" href={`${appUrl}${copy.canonicalPath}`} />
      </Head>

      <GastroHero
        loginUrl={loginUrl}
        whatsappUrl={whatsappUrl}
        promoDiscount={mayoristaPlusDiscount}
        title={copy.heroTitle}
        subtitle={copy.heroSubtitle}
        description={copy.heroDescription}
      />
      <SocialProof stats={stats} />
      <ProblemSection />
      <SmartPricing />
      <GastroStandard />
      <Professionalize />
      <TargetAudience />
      <GastroProducts products={featuredProducts} />
      <FinalCTA
        loginUrl={loginUrl}
        whatsappUrl={whatsappUrl}
        promoDiscount={mayoristaPlusDiscount}
        title={copy.ctaTitle}
        subtitle={copy.ctaSubtitle}
      />
      <SEOBlock
        appUrl={appUrl}
        path={copy.canonicalPath}
        seoTitle={copy.seoTitle}
        seoDescription={copy.seoDescription}
      />
    </MainLayout>
  );
}
